module.exports = __webpack_public_path__ + "img/5.00c2e311.png";